/*
 * File: UpdateCoursePeriod.ts
 * Author: Austin Robinson
 * Date Created: 6/9/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { privateApi } from 'api';

export interface UpdateCoursePeriodParams {
  coursePeriodId: string;
  courseSectionId: string;
  start: string;
  end: string;
  openEnrollment: string | null;
  closeEnrollment: string | null;
  capacity: number;
  instructors: string[];
}

async function updateCoursePeriod(params: UpdateCoursePeriodParams | undefined): Promise<boolean> {
  if (params === undefined) {
    return false;
  }

  const { coursePeriodId, ...rest } = params;
  // make api call
  await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/courses/periods/${coursePeriodId}`, rest, {
    // headers: {
    // }
  });

  // if (result.status >= 400) {
  //   throw new Error(result.data.message);
  // }

  // return the data object
  return true;
}

const useUpdateCoursePeriod = createMutation<boolean, UpdateCoursePeriodParams, AxiosError<unknown>>({
  mutationFn: async (variables: UpdateCoursePeriodParams) => updateCoursePeriod(variables),
});

export { updateCoursePeriod, useUpdateCoursePeriod };
